import React, { useEffect } from 'react';
import { useMobile } from '../hooks/useMobile';
import {
  preLoginUrls,
  isLinesPage,
  newDesignPathnames,
  is8DataApp,
  getShopifyParams,
  pathname,
} from '../utils';
import { makeStyles } from '@material-ui/core/styles';
import MobileBanner from './Mobile/Banner';
import Chat from './Chat';
import Influencer from './Influencer';
import Referral from './Referral';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuthContext, useDialogsContext } from '../contexts';
import SwitchShopDialog from './modals/SwitchShopDialog';
import { getShopifyAccounts } from './API/shopify';

const useStyles = makeStyles((theme: any) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
  },
  currentStyle: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingTop: () => theme.spacing(9),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  },
  noPadding: {
    padding: 0,
  },
  newDesignPadding: {
    paddingBottom: theme.spacing(3),
  },
}));

export default function Content({ children }) {
  const location = useLocation();
  const authPage = preLoginUrls.includes(location.pathname);
  const linesPage = isLinesPage();
  const isNewDesign = newDesignPathnames.includes(location.pathname);
  const classes = useStyles();
  const mobile = useMobile();
  const { signedIn, signOut } = useAuthContext();
  const dialogs: any = useDialogsContext();
  const history = useHistory();

  let paddingClass: string = classes.currentStyle;
  if (authPage || linesPage) {
    paddingClass = classes.noPadding;
  } else if (isNewDesign) {
    paddingClass = classes.newDesignPadding;
  }

  async function validateSameShopifyShop() {
    const result = await getShopifyAccounts();
    if (result.accounts.length > 0) {
      const shop = result.accounts[0].shop;
      const params = getShopifyParams();
      if (params && shop !== params.shop) {
        dialogs.open('switchShop');
      }
    }
  }

  const handleClose = () => {
    dialogs.close('switchShop');
  };

  const handleSwitch = async () => {
    await signOut();
    handleClose();
    history.push(pathname.preLogin.getStarted.accountCreation.url);
  };

  useEffect(() => {
    if (signedIn && is8DataApp()) {
      validateSameShopifyShop();
    }
    // eslint-disable-next-line
  }, [signedIn]);

  return (
    <div className={`${classes.content} ${paddingClass}`}>
      <Influencer />
      <Referral />
      {mobile && !authPage && <MobileBanner />}
      {children}
      {dialogs.switchShop && (
        <SwitchShopDialog
          open={dialogs.switchShop}
          handleClose={handleClose}
          handleSwitch={handleSwitch}
        />
      )}
      <Chat />
    </div>
  );
}
